module.exports = __webpack_public_path__ + "static/media/icon-brandidentity.ab8fec0a.svg";